/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageCapture/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import Questions from './Questions/index'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function ImageCapture({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture"
  
}) {
  let isMedia = useIsMedia()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Questions'
  return (<React.Fragment
>
<div
  data-testid="ImageCapture.Vertical"
  data-view-path={viewPath}
 style={{'--h-1-1xYaF2': isMedia.mobile ? "auto" : "auto",'--fg-2-1xYaF2': isMedia.mobile ? 1 : 0}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'Questions'}>
<Questions
  viewPath={`${viewPath}/Questions`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}